/**
 * The dashboard's "Needs your attention", as codes (review #45). Moved from the portal's
 * `apps/web-app/src/routes/dashboard/dashboard-screen.tsx` (plan-034 VIEW-PKG); the portal and the app word each item
 * with their own catalog phrase and decide where its action leads.
 *
 * What the dashboard can know needs the owner, from the VoiceAgent list alone: a failed build cannot answer anything,
 * and a VoiceAgent in the `live` state with no number cannot be reached by a caller. Every failed build comes first,
 * then every unreachable VoiceAgent, each in the list's order; anything the gateway's own attention feed carries
 * follows these, in the feed's order (the api answers no feed today, `null`).
 */
/** The attention items, in the dashboard's order; keys are stable per VoiceAgent and per feed position. */
export function attentionOf(voiceAgent, fed) {
    const item = [];
    for (const one of voiceAgent) {
        if (one.state === "failed") {
            item.push({ code: "build_failed", key: `failed-${one.voiceAgentId}`, tone: "critical", voiceAgentId: one.voiceAgentId, displayName: one.displayName });
        }
    }
    for (const one of voiceAgent) {
        if (one.state === "live" && one.partyNumber === null) {
            item.push({ code: "no_party_number", key: `number-${one.voiceAgentId}`, tone: "muted", voiceAgentId: one.voiceAgentId, displayName: one.displayName });
        }
    }
    for (const [index, one] of (fed ?? []).entries()) {
        item.push({ code: "fed", key: `fed-${String(index)}`, tone: one.tone, fed: one });
    }
    return item;
}
//# sourceMappingURL=attention.js.map